//GUS
export const GUS = '/api/v1/gus';

//OWNER
export const OWNER = '/api/v1/owners';

//NURSERY_REGISTRY
export const NURSERY_REGISTRY = '/api/v1/nurseries-registry';
